import moment from 'moment';

function resolveProgramYear(arrivalDate) {
  if (arrivalDate === null || arrivalDate === undefined || arrivalDate === '') {
    return '2022';
  }

  const parsedDate = Date.parse(arrivalDate);

  return moment(parsedDate).format('YYYY-MM-DD') < moment('2022-01-02').format('YYYY-MM-DD')
    ? '2021'
    : '2022';
}

function isEligibleFor2021(roomType, countryUser) {
  if (String(roomType.year) !== '2021') {
    return false;
  }

  const roomTypeId = Number(roomType.Id_MarivalRoomType);

  if (roomTypeId === 16 || roomTypeId === 17) {
    if (countryUser !== 167) {
      return false;
    }

    const today = new Date();
    const todayPromotion = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    const promotionEndDate = new Date('2020-08-09');

    return new Date(todayPromotion) <= promotionEndDate;
  }

  if (countryUser === 40) {
    return ![1, 2, 4, 7, 9, 10, 19].includes(roomTypeId);
  }

  return ![5, 8, 11, 12, 20].includes(roomTypeId);
}

function isEligibleFor2022(roomType, countryUser) {
  if (String(roomType.year) !== '2022') {
    return false;
  }

  if (countryUser === 40) {
    return Number(roomType.canada) === -1;
  }

  if (countryUser === 167) {
    return Number(roomType.mexico) === -1;
  }

  if (countryUser === 254) {
    return Number(roomType.usa) === -1;
  }

  return false;
}

export function getEligibleRoomTypes(roomTypes, arrivalDate, countryUser) {
  const programYear = resolveProgramYear(arrivalDate);

  return roomTypes.filter((roomType) => (
    programYear === '2021'
      ? isEligibleFor2021(roomType, countryUser)
      : isEligibleFor2022(roomType, countryUser)
  ));
}
